
import { FormSection } from '../../../../forms/FormSection'
import { PolicyHolderForm } from '../forms/PolicyHolderForm'
import type { BaseContainerProps } from '.'

export const PolicyHolder = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <PolicyHolderForm />
    </FormSection>
  )
}
